import React, { MouseEvent } from 'react';
import { styled } from '@mui/material';
import { Button } from '@mui/material';

const PREFIX = 'DateFilter';

const classes = {
  buttonContainer: `${PREFIX}-buttonContainer`,
  buttonStyle: `${PREFIX}-buttonStyle`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.buttonContainer}`]: {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2),
  },

  [`& .${classes.buttonStyle}`]: {
    border: 'none !important',
  },
}));

type DateFilterProps = {
  value: string;
  handleChange: (event: MouseEvent<{ value: string }>) => void;
};

const DateFilter = ({ value, handleChange }: DateFilterProps) => (
  <Root className={classes.buttonContainer}>
    <Button
      className={classes.buttonStyle}
      variant={value === 'month_3' ? 'contained' : 'outlined'}
      color="primary"
      value="month_3"
      onClick={handleChange}>
        3M
    </Button>
    <Button
      className={classes.buttonStyle}
      variant={value === 'month_6' ? 'contained' : 'outlined'}
      color="primary"
      value="month_6"
      onClick={handleChange}>
        6M
    </Button>
    <Button
      className={classes.buttonStyle}
      variant={value === 'year_1' ? 'contained' : 'outlined'}
      color="primary"
      value="year_1"
      onClick={handleChange}>
        1Y
    </Button>
    <Button
      className={classes.buttonStyle}
      variant={value === 'year_3' ? 'contained' : 'outlined'}
      color="primary"
      value="year_3"
      onClick={handleChange}>
        3Y
    </Button>
    <Button
      className={classes.buttonStyle}
      variant={value === 'year_5' ? 'contained' : 'outlined'}
      color="primary"
      value="year_5"
      onClick={handleChange}>
        5Y
    </Button>
    <Button
      className={classes.buttonStyle}
      variant={value === 'year_10' ? 'contained' : 'outlined'}
      color="primary"
      value="year_10"
      onClick={handleChange}>
        10Y
    </Button>
  </Root>
);

export default DateFilter;
